import React from "react";
import classes from './Courses.module.css';
import PropTypes from 'prop-types';
import Discipline from "../Disciplines/Discipline";
import Course from './Course';
import { isJson } from "../../../utils";


const Courses = ({ filteredlist, getPassUrlFromCourse }) => {
    return (<div className={classes.Courses}>
        {filteredlist && filteredlist.map(c => <Course  actions={true} key={c.id} {...c} color={isJson(c.additionalData) && JSON.parse(c.additionalData) ? JSON.parse(c.additionalData).color : "#11335B"} getPassUrlFromCourse={getPassUrlFromCourse}></Course>)}
        <Course color="#11335B" create></Course>
    </div>)
}

Courses.propTypes = {
    courses: PropTypes.array
}

export default Courses;